var map = {
	"./1.png": 9366,
	"./2.png": 2826,
	"./3.png": 9426,
	"./4.png": 4702,
	"./5.png": 8281,
	"./6.png": 9993,
	"./7.png": 4813,
	"./8.png": 6075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;